import { useNavigate } from '@tanstack/react-router';
import { useRevealLastViewedRow } from '@/hooks/useLastViewedRow';
import {
  DONATION_DECISION_STEP,
  type DonationDecisionStep,
  type DonationDetailOrigin,
} from '../constants/marketPromotion.constants';
import type { MpApprovalRow } from '../types/marketPromotion.types';

export function useOpenDonationDetail(from: DonationDetailOrigin) {
  const navigate = useNavigate();
  const lastViewedDetailId = useRevealLastViewedRow('donations');

  const openDonationDetail = (donation: MpApprovalRow) => {
    void navigate({
      to: '/market-promotion/approvals/$detailId',
      params: { detailId: donation.detailId },
      search: { from },
    });
  };

  const openDonationDecision = (donation: MpApprovalRow, step: DonationDecisionStep) => {
    void navigate({
      to: '/market-promotion/approvals/$detailId',
      params: { detailId: donation.detailId },
      search: { from, step },
    });
  };

  const decisionActions = {
    onRecommend: (donation: MpApprovalRow) =>
      openDonationDecision(donation, DONATION_DECISION_STEP.recommend),
    onDecide: (donation: MpApprovalRow) =>
      openDonationDecision(donation, DONATION_DECISION_STEP.approve),
  };

  const isDonationHighlighted = (donation: MpApprovalRow) =>
    donation.detailId === lastViewedDetailId;

  return { openDonationDetail, decisionActions, isDonationHighlighted };
}
